export default __webpack_public_path__ + "static/UAE-7cb26510dc6fc13df3ebe762bab1b184.svg";